import { Befehl2 } from '../../../models'
import {
  BefehlAuftrag_2_10Dto,
  BefehlAuftrag_2_25Dto,
  BefehlAuftrag_2_95Dto
} from '../../../dtos'
import {
  Befehl2FormData,
  Befehl2FormSchema
} from './schema/befehl2-form.schema'
import {
  createFreitextAuftrag,
  createSimpleAuftrag,
  findAuftragByKennung,
  hasAuftrag
} from '../converter-utils'
import { Befehl2DataDto } from '../../../dtos/befehl-2-dto'

export const convertModelToBefehl2FormData = (
  befehl?: Befehl2
): Befehl2FormData => {
  const formData = Befehl2FormSchema.parse({})

  if (!befehl?.auftraege) {
    return formData
  }

  if (hasAuftrag(befehl.auftraege, '2.10')) {
    formData.auftrag_2_10.enabled = true
  }

  if (hasAuftrag(befehl.auftraege, '2.25')) {
    formData.auftrag_2_25.enabled = true
  }

  const auftrag295 = findAuftragByKennung(befehl.auftraege, '2.95')
  if (auftrag295) {
    formData.auftrag_2_95.enabled = true
    const feld296 = auftrag295.felder?.find((f) => f.kennung === '2.96')
    if (feld296?.werte?.freitext) {
      formData.auftrag_2_95.freitext = feld296.werte.freitext
    }
  }

  return formData
}

export const convertBefehl2FormDataToModel = (
  formData: Befehl2FormData,
  frontendId: string
): Befehl2 => {
  const auftraege: Befehl2DataDto = []

  if (formData.auftrag_2_10?.enabled) {
    auftraege.push(createSimpleAuftrag('2.10', true) as BefehlAuftrag_2_10Dto)
  }

  if (formData.auftrag_2_25?.enabled) {
    auftraege.push(createSimpleAuftrag('2.25', true) as BefehlAuftrag_2_25Dto)
  }

  if (formData.auftrag_2_95?.enabled) {
    auftraege.push(
      createFreitextAuftrag(
        '2',
        true,
        formData.auftrag_2_95?.freitext || ''
      ) as BefehlAuftrag_2_95Dto
    )
  }

  return {
    kennung: '2',
    frontendId,
    auftraege
  }
}
